/**
 * Vérifie si un objet est du type T en vérifiant l'existance de la clé key au sein de l'objet
 * @param obj
 * @param key
 */
export function isTypeOf<T>(obj: any, key: string): obj is T {
    return key in obj;
}